import request from '../../../helpers/request';

const changeRoomServices = async (services, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      companyServices: services || [],
    },
    'При изменении списка услуг произошла ошибка'
  );
};

export default changeRoomServices;
